<!-- /src/App.vue -->
<template>
  <div id="app">
    <!-- Overlay for loading -->
    <div v-if="appLoading" class="app-loading-overlay">
      <!-- Your spinner or "Loading..." message goes here -->
      <p>Loading application...</p>
      <div class="spinner"></div> <!-- Replace with your actual spinner component or CSS -->
    </div>

    <!-- Main app content, shown only when not loading -->
    <template v-else>
      <Notifications />
      <main :class="[{'dark-headerBg': darkBg}, pageClasses]">
        <Header v-if="isAuthenticated" class="layout__header" />
        <transition name="router-transition" mode="out-in">
          <router-view />
        </transition>
      </main>
    </template>
  </div>
</template>


<script>
import { mapGetters } from 'vuex'
import Notifications from '@/components/common/Notifications'
import Header from '@/components/common/Header/Header'
import forEach from 'lodash/forEach'
import questionMixin from '@/mixins/questionMixin'

export default {
  data() {
    return {
      // pageClasses: '',
      backgrounds: [],
      appLoading: true, // Start as true
    }
  },

  mixins: [
    questionMixin,
  ],

  components: {
    Notifications,
    Header,
  },

  computed: {
    ...mapGetters({
      isAuthenticated: 'user/authCheck',
      user: 'user/getUser',
    }),

    pageClasses() {
      return this.$store.getters['getPageClasses']
    },

    pageTitle() {
      return this.$store.getters['pageTitle']
    },

    darkBg() {
      return this.$store.getters['checkBgImage'] || this.$store.getters['checkBgDark'];
    },
    
    gaUser() {
      const { user } = this
      const { id, username, name, first_name, last_name, email } = user
      let output = {
        id,
        username,
        name,
        first_name,
        last_name,
        email
      }
      // output = 
      return JSON.stringify(output, null, 4)
    },

  },

  methods: {
    createUserScript() {
      let userScript = document.getElementById('currentUser')
      if (userScript == null) {
        const gascript = document.querySelector('script[src="https://www.google-analytics.com/analytics.js"]');
        const inlineScript = document.createTextNode(`const currentUser = ${this.gaUser};`);
        userScript = document.createElement('script')
        userScript.setAttribute('id', 'currentUser')
        userScript.setAttribute('type', 'text/javascript')
        userScript.appendChild(inlineScript); 
        document.head.insertBefore(userScript, gascript)
      } else {
        userScript.textContent = `const currentUser = ${this.gaUser};`;
      }
      // var gascript = null;
      // var scripts = document.getElementsByTagName( 'script' );
      // for (var i = 0; i < scripts.length; ++i) {
      //   if (this.lookingfor(scripts[i])) gascript = scripts[i]
      // }
    },

    preloadImages() {
      // Get HTML head element
      const head = document.getElementsByTagName('HEAD')[0]; 
      forEach(this.backgrounds, bg => {
        if (bg !== null) {
          // Create new link Element
          var link = document.createElement('link');
    
          // set the attributes for link element 
          link.rel = 'preload'; 
          link.as = 'image';
          link.href = bg; 
    
          // Append link element to HTML head
          head.appendChild(link); 
        }
      })
    },

    checkRoute() {
      const { $route } = this
      // console.log({'showForm': this.showForm, includeQuestion: this.includeQuestion})
    }
  },

  watch: {
    // Watch for changes in isAuthenticated to potentially trigger side effects
    // This isn't strictly necessary for the header's v-if, but good for other effects.
    isAuthenticated(newValue, oldValue) {
      if (newValue && !oldValue) {
        // User just became authenticated
        this.$store.dispatch('user/initializeSessionAuth');
      } else if (!newValue && oldValue) {
        // User just became unauthenticated (logged out)
        // No explicit action needed here for header, as v-if handles it.
      }
    },

    user() {
      this.createUserScript() // create the user script for GA
    },
    pageTitle(title) {
      document.title = title
    },
    $route() {
      this.checkRoute()
    },
  },

  mounted () {
      this.appLoading = false;

      this.createUserScript() // create the user script for GA
      this.backgrounds = this.$store.getters['posts/getAll']('funnelImages')
      this.preloadImages()
      this.checkRoute()

      document.title = this.pageTitle
  },

  // async updated() {
  //   document.title = await this.$store.getters['pageTitle']
  // }
}
</script>

<style>
#app {
  /* position: relative; */
  /* height: 100vh; */
  /* perspective: 100vh; */ /* commented this out because it keeps notifications from being fixed on page*/
  width: fit-content;
  min-width: 100vw;

  /* @media(--phone) {
    width: 100vw;
  } */
  /* overflow-x: hidden; */
  > main {
    display: grid;
    /* width: 100%; */
    min-height: 100vh;
    grid-template-rows: auto 1fr;

    &.no-branding-header {
      grid-template-rows: 1fr;
    }
  }
}

main {
  position: relative;
  /* width: 100%; */
  min-height: 100vh;

  &:after {
    pointer-events: none;
    content: '';
    height: 400px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    background: linear-gradient(to bottom, rgba(var(--gray-RGB), .95), rgba(var(--gray-RGB), 0));
    transition: background .5s linear;
    z-index: -1;
  }

  &.dark-headerBg {
    &:after {
      background: linear-gradient(to bottom, rgba(0, 0, 0, .95), rgba(0, 0, 0, 0));
    }
  }
}

.preloadImages {
  display: none;
}


.router-transition-enter-active,
.router-transition-leave-active {
  transition: opacity 0.5s ease, transform 0.5s ease;
  /* will-change: transform, opacity; */

  .layout__content__columns__left,
  .layout__content__columns__right {
    transition: opacity 0.5s ease-in-out, transform 0.5s ease-in-out;
    /* will-change: transform, opacity; */
  }

  .layout--content--container {
    transition: opacity 0.5s ease-in-out, transform 0.5s ease-in-out;
    /* will-change: transform, opacity; */
  }
}

.router-transition-enter,
.router-transition-leave-to {
  /* opacity: 0; */
  /* transform: scale(1.2); */

  .layout__content__columns__left {
    transform: translateX(-20%);
    opacity: 0;
  }

  .layout__content__columns__right {
    transform: translateX(20%);
    opacity: 0;
  }
  .layout--content--container {
    transform: translateY(-20%);
    opacity: 0;
  }
}

/* Basic styling for the overlay and spinner */
.app-loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: var(--brand-primary-color, #f0f0f0); /* Or your app's background color */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 9999; /* Ensure it's on top */
  color: rgba(var(--gray-RGB), .95); /* Or a contrasting color */
}
/* Spinner styles (placeholder, replace with your actual spinner) */
.spinner {
  border: 4px solid rgba(var(--gray-RGB), .95);
  border-top: 4px solid var(--brand-primary-color, #f0f0f0);
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite;
  margin-top: 20px;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
